import { s as sharedStore } from '../../../../../../_virtual/shared-store.mjs';
import global from './global.mjs';
import defineGlobalProperty$1 from './define-global-property.mjs';

var globalThis = global;
var defineGlobalProperty = defineGlobalProperty$1;

var SHARED = '__core-js_shared__';
var store = sharedStore.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.37.0',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var exports = sharedStore.exports;
export { exports as default };
